import { Button, Container } from './styles';
import { useManifest } from './useManifest';

export const BundleExpiredBanner = () => {
  const isBundleExpired = useManifest();

  if (!isBundleExpired) {
    return null;
  }

  return (
    <Container>
      <span>
        {'A new update for RideIQ is available. Refresh your browser to use our latest version.'}
        <Button onClick={() => window.location.reload()}>Refresh page</Button>
      </span>
    </Container>
  );
};
